// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-39914945]{background:#111115}.v-icon[data-v-39914945]{background:#1e1e1e;border-radius:100%;display:flex;align-items:center;justify-content:center;width:50px;height:50px}", ""]);
// Exports
module.exports = exports;
